import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, ButtonGroup, Button } from "shards-react";
import { NavLink } from "react-router-dom";

import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats";
import CountryReports from "../components/common/CountryReports";
import DeviceScoreReport from "../components/ecommerce/DeviceScoreReport";
import SalesByCategory from "../components/ecommerce/SalesByCategory";
import UserStats from "./../components/detection-profile/TopManufacturer";

import UserStats1 from "./../components/detection-profile/TopModels";



import "./loaderStyles.css"; // Import your CSS file for the loader
import colors from "../utils/colors";
import { useAuth } from '../context/AuthContext';

const OnlineStore = () => {
  const { logout } = useAuth(); 
  const [smallStats, setSmallStats] = useState([
    {
      label: "Threats Blocked",
      value: "0",
      percentage: "0%",
      description: "Jail Broken Detection, and other non-exit events...",
      increase: true,
      loading: true, // Initialize loading state for threats
      datasets: [
        {
          data: [0]
        }
      ]
    },
    {
      label: "App Shutdown",
      value: "0",
      percentage: "0%",
      description: "Debugging, hooking, emulator, and other events...",
      increase: true,
      loading: true, // Initialize loading state for app shutdowns
      datasets: [
        {
          data: [0]
        }
      ]
    },
    //   {
    //   label: "App Shutdown",
    //   value: "0",
    //   percentage: "0%",
    //   description: "Debugging, hooking, emulator, and other events...",
    //   increase: true,
    //   loading: true, // Initialize loading state for app shutdowns
    //   datasets: [
    //     {
    //       data: [0]
    //     }
    //   ]
    // },
    //   {
    //   label: "App Shutdown",
    //   value: "0",
    //   percentage: "0%",
    //   description: "Debugging, hooking, emulator, and other events...",
    //   increase: true,
    //   loading: true, // Initialize loading state for app shutdowns
    //   datasets: [
    //     {
    //       data: [0]
    //     }
    //   ]
    // },
    
  ]);

  useEffect(() => {
    const fetchData = async () => {
   

      const companyId = localStorage.getItem('company_id');
      const token = localStorage.getItem("token");
    //  const comp_id=localStorage.getItem('company_id');
     // const token=localStorage.getItem('token');
      
      if(!companyId||companyId==''||!token||token==''){ 
       logout();
     }


      try {
        const response = await fetch("https://vaptlabreport.com/shieldapi/total_threats_blocked_shutdown_info.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ company_id: companyId, os: "ios" }),
        });
        const data = await response.json();

        if (data.status === "success") {
          setSmallStats((prevStats) => prevStats.map((stat) => {
            if (stat.label === "Threats Blocked") {
              return {
                ...stat,
                value: data.total_threats_blocked,
                loading: false, // Set loading to false once data is fetched
                datasets: [{ data: [data.total_threats_blocked] }]
              };
            } else if (stat.label === "App Shutdown") {
              return {
                ...stat,
                value: data.total_app_shutdowns,
                loading: false, // Set loading to false once data is fetched
                datasets: [{ data: [data.total_app_shutdowns] }]
              };
            }
            return stat; // Return unchanged stat
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSmallStats((prevStats) => prevStats.map(stat => ({ ...stat, loading: false }))); // Stop loading on error
      }
    };

    fetchData();
  }, []);

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle title="Detection Overview" subtitle="ios" className="text-sm-left mb-3" />

        {/* Page Header :: Actions */}
        <Col sm="4" className="col d-flex align-items-center">
          <ButtonGroup size="sm" className="d-inline-flex mb-3 mb-sm-0 mx-auto">
            <Button theme="white" tag={NavLink} to="/detection_overview_android">
              Android
            </Button>
            <Button theme="white" tag={NavLink} to="/detection_overview_ios">
              iOS
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      {/* Small Stats Blocks */}
      <Row>
        {smallStats.map((stats, idx) => (
          <Col key={idx} md="6" lg="3" className="mb-4">
            {stats.loading ? (
              <div className="text-center">
                <div className="spinner" /> {/* Spinner loader */}
                <p>Loading...</p>
              </div>
            ) : (
              <SmallStats
                id={`small-stats-${idx}`}
                chartData={stats.datasets}
                chartLabels={stats.chartLabels}
                label={stats.label}
                value={stats.value}
                percentage={stats.percentage}
                description={stats.description}
              />
            )}
          </Col>
        ))}
      </Row>

      <Row>
        {/* Sales Report */}
         <Col lg="8" md="12" sm="12" className="mb-4">
          <DeviceScoreReport os="ios"/>
        </Col>

        {/* Sales by Categories */}

        <Col lg="4" md="6" sm="6" className="mb-4">
                  <SalesByCategory title="Top Threats" os="ios"/>
        </Col>
      </Row>

      <Row>
        {/* Country Reports */}
        {/*
        <Col lg="4" className="mb-4">
          <CountryReports title="Sales by country" />
        </Col>
      */}


 <Col lg="4" className="mb-4">
          <UserStats title="Top TopManufacturer" os="ios" />
        </Col>

 <Col lg="4" className="mb-4">
          <UserStats1 title="Top Models" os="ios" />
        </Col>       
       
      </Row>
    </Container>
  );
};

OnlineStore.propTypes = {
  /**
   * The data for the small stats.
   */
  smallStats: PropTypes.array,
};

export default OnlineStore;
